import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { compareStrings } from '@cbridge-utils/object';
import { IMarkupProfile } from '../markupProfile.interface';
import { markupProfileStoreSelector } from '../markupProfile.selector';

export const markupProfileListSelector = createCachedSelector(
  [
    path(markupProfileStoreSelector).data(),
    path(markupProfileStoreSelector).listNetworkStatus(),
  ],
  (data, networkStatus) => {
    const list: IMarkupProfile[] = Object.values(data)
      .sort((a, b) => compareStrings(a.markupProfileName, b.markupProfileName));
    return {
      list,
      networkStatus,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
